'use client';
import React from 'react';

import IconLinkButton from '@/assets/icons/iconLinkButton.svg';
import { Button } from '@/shared/components/button';

export interface ListProps {
  mapPageTranslations: Record<string, string>;
}

export const List = ({ mapPageTranslations }: ListProps) => {
  return (
    <div className="flex w-[268px] min-w-[268px] flex-col gap-4 text-[14px] leading-[18px] font-normal max-sm:w-full">
      <div
        id="styleEditorFeaturesItem1"
        className="bg-custom-surface-contrast-low text-text-base-primary rounded-2xl pt-4 pr-6 pb-4 pl-6"
      >
        {mapPageTranslations.styleEditorFeature1}
      </div>
      <div
        id="styleEditorFeaturesItem2"
        className="bg-custom-surface-contrast-low text-text-base-primary rounded-2xl pt-4 pr-6 pb-4 pl-6"
      >
        {mapPageTranslations.styleEditorFeature2}
      </div>
      <div
        id="styleEditorFeaturesItem3"
        className="bg-custom-surface-contrast-low text-text-base-primary rounded-2xl pt-4 pr-6 pb-4 pl-6"
      >
        {mapPageTranslations.styleEditorFeaturesItem3}
      </div>
      <div
        id="styleEditorFeaturesItem4"
        className="bg-custom-surface-contrast-low text-text-base-primary rounded-2xl pt-4 pr-6 pb-4 pl-6"
      >
        {mapPageTranslations.styleEditorFeaturesItem4}
      </div>
      <Button
        id="styleEditorButtonText"
        className="flex h-14 items-center justify-center"
        variant="primary"
        href={mapPageTranslations.linkStyleEditorDocs}
        target="_blank"
        ariaLabel="buttonOpenDocumentation"
      >
        {mapPageTranslations.buttonOpenDocumentation} <IconLinkButton />
      </Button>
    </div>
  );
};
